import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ConfirmationModal from '../../Components/common/ConfirmationModal';
import Loader from '../../Components/common/loader/loader';
import './AddUser.css';
import { useAddUserPage } from './useAddUserPage';
import AddUserUserInfoSection from './AddUserUserInfoSection';
import AddUserAssetVisibility from './AddUserAssetVisibility';

const loadingUserDataStyle: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '400px',
    fontSize: '16px',
    color: '#666',
};

const AddUser: React.FC = () => {
    const page = useAddUserPage();

    return (
        <div className="add-user-container" style={{ position: 'relative' }}>
            {page.isOverlayLoading && <Loader isOverlay={true} />}
            <ToastContainer
                position="top-right"
                autoClose={2000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                style={{ marginTop: '60px', zIndex: 9999 }}
            />

            <ConfirmationModal
                isOpen={page.showDeleteModal}
                title="Delete User"
                message="Are you sure you want to delete this user? This action cannot be undone."
                confirmText="Delete"
                cancelText="Cancel"
                onConfirm={page.confirmDelete}
                onCancel={page.cancelDelete}
                isDestructive={true}
            />

            <div className="page-header">
                <h2>{page.isEditMode ? 'Edit User' : 'Add User'}</h2>
                <div className="add-user-actions">
                    <button type="button" className="btn-cancel" onClick={() => page.navigate('/users')}>
                        Cancel
                    </button>
                    {page.isEditMode && (
                        <button
                            type="button"
                            className="btn-delete-user"
                            onClick={() => page.userId && page.handleDelete(page.userId)}
                        >
                            Delete
                        </button>
                    )}
                    <button
                        type="button"
                        className="btn-save"
                        onClick={page.handleSave}
                        disabled={page.loading || page.loadingUserData}
                    >
                        {page.loading ? 'Saving...' : 'Save'}
                    </button>
                </div>
            </div>

            {page.loadingUserData ? (
                <div style={loadingUserDataStyle}>
                    Loading user data... (Edit mode: {page.isEditMode ? 'true' : 'false'}, UserId: {page.userId})
                </div>
            ) : (
                <div className="form-sections-container">
                    <AddUserUserInfoSection
                        formData={page.formData}
                        errors={page.errors}
                        customers={page.customers}
                        isEditMode={page.isEditMode}
                        showPassword={page.showPassword}
                        showEncryptedPassword={page.showEncryptedPassword}
                        onInputChange={page.handleInputChange}
                        onUserTypeChange={page.setUserType}
                        onSsoEnabledChange={page.setSsoEnabled}
                        onToggleShowPassword={() => page.setShowPassword(!page.showPassword)}
                    />
                    <AddUserAssetVisibility
                        formData={page.formData}
                        searchText={page.searchText}
                        displayCustomers={page.displayCustomers}
                        expandedItems={page.expandedItems}
                        onSearch={page.handleSearch}
                        onSelectAll={page.handleSelectAll}
                        getTotalCount={page.getTotalCount}
                        isCustomerSelected={page.isCustomerSelected}
                        isSiteSelected={page.isSiteSelected}
                        isPlantSelected={page.isPlantSelected}
                        onCustomerSelect={page.handleCustomerSelect}
                        onSiteSelect={page.handleSiteSelect}
                        onPlantSelect={page.handlePlantSelect}
                        onToggleExpand={page.toggleExpand}
                    />
                </div>
            )}
        </div>
    );
};

export default AddUser;
